<template>
	<div class="bgCol fourth">
		<div class="item_btn">
			<el-button class="edit_btn" type="primary" plain size="small" v-if="detail.is_edit===true"
				@click="addMaterial()">添加<span v-if="is_sort==0">肥料</span><span v-if="is_sort==1">农资</span></el-button>
			
		</div>
		<div class="item">
			<el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName" style="margin-top: 40px;">
				<el-table-column prop="type_name" label="农资种类"></el-table-column>
				<el-table-column prop="name" label="农资名称"></el-table-column>
				<el-table-column prop="dosage" label="农资用量"></el-table-column>

				<el-table-column label="操作" v-if="detail.is_edit===true">
					<template slot-scope="scope">
						<el-button class="edit_btn" type="primary" plain size="small"
							@click="editMaterial(scope.$index)">编辑</el-button>
						<el-button class="del_btn" type="danger" plain size="small"
							@click="deleteMaterial(scope.$index)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<WxMessageBox :show="materialShow" @save="materialSave" @canse="materialCanse">
			<div slot="content">
				<el-form :model="mForm" :rules="mRules" ref="mForm">
					<div class="wx_form">
						<div class="form_item">
							<div class="label">选择分类:</div>
							<div class="input">
								<el-form-item label="" prop="cate_id" size="medium" v-if="is_sort==0">
									<el-select v-model="mForm.cate_id" placeholder="请选择" @change="changeCategory"
										clearable>
										<el-option :label="item.name" v-for="(item,index) in material_category_list"
											:key="'material_category'+index" :value="item.id" v-if="item.id==17">
											{{item.name}}
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="" prop="cate_id" size="medium" v-if="is_sort==1">
									<el-select v-model="mForm.cate_id" placeholder="请选择" @change="changeCategory"
										clearable>
										<el-option :label="item.name" v-for="(item,index) in material_category_list"
											:key="'material_category'+index" :value="item.id" v-if="item.id!=17">
											{{item.name}}
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="form_item">
							<div class="label">选择肥料:</div>
							<div class="input">
								<el-form-item label="" prop="material_id" size="medium">
									<el-select v-model="mForm.material_id" placeholder="请选择"  @change="changeMaterial">
										<el-option :label="item.name" v-for="(item,index) in materials_list"
											:key="'material'+index" :value="item.id">{{item.name}}{{item.dosage_units_name}}
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="form_item">
							<div class="label">使用量:</div>
							<div class="input">

								<el-form-item label="" prop="dosage">
									<el-input v-model="mForm.dosage" type="number" :placeholder="dosage_units_name"></el-input>
								</el-form-item>
							</div>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
	</div>
</template>

<script>
	import {
		getMaterialList,
		getDictList
	} from '@/api/api'
	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "People",
		props: {
			detail: {
				type: Object,
				default: () => []
			},

			work_task_id: {
				type: Number,
				default: 0
			},
			is_sort: {
				type: Number,
				default: 0
			},
			is_weather: {
				type: Number,
				default: 0
			},
			tableData: {
				type: Array,
				default: () => []
			},
			is_edit: {
				type: Boolean,
				default: true
			}

		},
		data() {
			return {
				is_action: 1,
				index: '',
				materialShow: false,
				material_category_list: [],
				materials_list: [],
				dosage_units_name:'请填写使用量',
				mForm: {
					id: '',
					cate_id: '',
					material_id: '',
					dosage: '',
				},
				mRules: {
					cate_id: [{
						required: true,
						message: '必选',
						trigger: 'change'
					}],
					material_id: [{
						required: true,
						message: '必选',
						trigger: 'change'
					}],
					dosage: [{
						required: true,
						message: '必填',
						trigger: 'blur'
					}],

				},


			}

		},
		created() {
			getDictList(16).then(resp => {
				this.material_category_list = resp
			})
			
			console.log(this.tableData)

		},

		methods: {

			changeCategory(val) {

				getMaterialList(this.$route.params.id, val).then(resp => {
					this.materials_list = resp
				})
			},
			changeMaterial(val){
				this.materials_list.forEach((item,index)=>{
					if(val==item.id){
						this.mForm.dosage='',
						this.dosage_units_name="单位:"+item.dosage_units_name
					}
				})
			},
			// 表格斑马纹
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 !== 1) {
					return 'single-row';
				} else {
					return 'double-row';
				}
			},
			addMaterial() {
				this.is_action=1
				getMaterialList(this.$route.params.id, 17).then(resp => {
					this.material_list = resp
					this.materialShow = true
				})

			},
			deleteMaterial(index) {
				this.tableData.forEach((val, key) => {
					if (key == index) {
						this.tableData.splice(this.tableData.indexOf(val), 1);;
					}
				})
			},
			editMaterial(index) {
				this.is_action = 2;
				this.index = index;
				getMaterialList(this.$route.params.id, 17).then(resp => {
					this.materials_list = resp
					this.tableData.forEach((val, key) => {
						if (key == index) {
							this.mForm["cate_id"] = val.cate_id
							this.mForm["material_id"] = val.id
							this.mForm["dosage"] = val.dosage
						}
					})

					this.materialShow = true
				})
			},
			materialSave() {
				
				this.$refs["mForm"].validate((valid) => {
					if (valid) {
						if (this.is_action == 2) {
							try {
								this.tableData.forEach((v, k) => {
									if ((v["id"] == this.mForm.material_id)&&(k!=this.index)) {
										this.$message.error("同一农资不能重复添加1")
										throw Error();
									}
								})
								
							} catch (e) {
								return false
							}
							
							this.tableData.forEach((item, index) => {
                              if(this.index==index){
								  this.tableData[index]["dosage"]=this.mForm.dosage
								   this.tableData[index]["cate_id"] = this.mForm.cate_id
								   this.tableData[index]["material_id"] = this.mForm.material_id
								   this.material_category_list.forEach((val, key) => {
								   	if (val.id == this.mForm.cate_id) {
								   		 this.tableData[index]["type_name"] = val.name
								   	}
								   })
								   this.materials_list.forEach((val, key) => {
								   	if (val.id == this.mForm.material_id) {
								   		 this.tableData[index]["name"] = val.name
								   	}
								   })
							  }
							})
							console.log(this.tableData)
							 this.mForm = this.$options.data().mForm 
						}else{
						this.materials_list.forEach((item, index) => {
							if (item.id == this.mForm.material_id) {
								item.dosage = this.mForm.dosage
								item.cate_id = this.mForm.cate_id
								item.material_id = this.mForm.material_id
								this.material_category_list.forEach((val, key) => {
									if (val.id == this.mForm.cate_id) {
										item.type_name = val.name
									}
								})
								try {
									this.tableData.forEach((v, k) => {
										if (v["id"] == item.id) {
											this.$message.error("同一农资不能重复添加2")
											throw Error();
										}
									})
									this.tableData.push(item)
								} catch (e) {}


							}

						})
						this.mForm = this.$options.data().mForm 
						
                       }
					   
						this.materialShow = false
					} else {
						
						return false;
					}
				});


			},
			// 添加/编辑农资弹窗取消
			materialCanse() {
				this.materialShow = false
			},

		},
		components: {
			WxMessageBox
		}

	}
</script>

<style>
</style>
